import { Component, OnInit } from '@angular/core';
import { DepotStockLocation } from '../../models/depot-stock-location.model';
import { DepotStockLocationValidatorService } from '../../validators/depot-stock-location-validator.service';
import { DepotStockLocationService } from '../../services/depot-stock-location.service';
import { take, catchError } from 'rxjs/operators';

@Component({
    selector: 'app-depot-stock-locations-new',
    templateUrl: './depot-stock-locations-new.component.html',
    styleUrls: ['./depot-stock-locations-new.component.scss'],
    standalone: false
})
export class DepotStockLocationsNewComponent implements OnInit {

  depotStockLocation: DepotStockLocation = new DepotStockLocation();

  isError: boolean = false;
  isServerError: boolean = false;

  constructor(private validator: DepotStockLocationValidatorService,
    private service: DepotStockLocationService) { }

  ngOnInit(): void {
  }

  onSubmit() {

    this.isError = false;
    this.isServerError = false;

    if(this.validator.isValid(this.depotStockLocation)) {
      this.service.createDepotStockLocation(this.depotStockLocation)
      .pipe(take(1))
      .pipe(catchError((e) => {
        if(e.status === 403 || e.status === 401){return e;}
        this.isServerError = true;
        return e;
      }))
      .subscribe(() => {
        window.location.href = '/workshop/depot-stock-locations';
      })
    } else {
      this.isError = true;
    }
  }

}
